import axios from 'axios'
import dayjs from 'dayjs'
import { addOrAppendAxiosHeader } from '@/services/axios'

const timezoneRequestInterceptor = (): void => {
  axios.interceptors.request.use(
    function (config) {
      config.headers = addOrAppendAxiosHeader(
        'x-verified-timezone',
        `${dayjs.tz.guess()}`,
        config.headers,
      )

      return Promise.resolve(config)
    },
    function (error) {
      return Promise.reject(error)
    },
  )
}

export default timezoneRequestInterceptor
